'use client';
import './ToolDetailsPage.css';
import '../tools/ToolsPage.css';
import './mocktest/bavaria/StateSelection.css';
import '../contact/Contact.css';
import { useRouter } from "next/navigation";
import { MdKeyboardArrowRight } from 'react-icons/md';
import strings from '../../config/App.json';
import modalTexts from '../../config/modalTexts.json';
import { useState } from 'react';
import useFetchQuestions from '@/Hooks/FetchQuestionsButton';
import useStartMockTest from '@/Hooks/startMockTest';
import { SideAds } from '@/components/Ads/Ads';
import ConfirmModal from '@/components/ConfirmModal/ConfirmModal';
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import ModalBox from '@/components/popupmodel/ModalBox';
import modalStrings from "../../config/modalStrings.json";

const ToolDetailsPage = () => {
  const router = useRouter();
  const { fetchQuestions, loading } = useFetchQuestions();
  const { startMockTest, loadingTest } = useStartMockTest(router, strings);
  const [isMockTestModalOpen, setMockTestModalOpen] = useState(false);
  const [openModalType, setOpenModalType] = useState(null);

  const handleModalStateChange = (type, isOpen) => {
    setOpenModalType(isOpen ? type : null);
  };

  return (
    <>
      <Header />
      <div className="tools-container">
        <div className="german-test-header">
          <button className="Home-button" onClick={() => router.push(strings.HomePage)}>
            <img src='/images/Tools/homeIcon.svg' alt="Home Icon" className="home-icon" />
          </button>
          <MdKeyboardArrowRight className="home-icon" />
          <span className="Home-text_ger">German Naturalization Test</span>
        </div>

        <div className="german-test-content-container">
          <div className="german-test-content">

            <h1 className="test-title">
              Einbürgerungstest Online 2026: Practice the German Citizenship Test
            </h1>

            <p className="test-description">
              The <span>German Naturalization Test (Einbürgerungstest)</span> is a mandatory requirement
              for applicants seeking German citizenship. Under the <b>2026 citizenship laws</b>, most applicants
              can apply after <b>5 years</b> of legal residence.
              At <b>Munich Indians</b>, we provide a free, updated simulation of the official BAMF catalog
              specifically tailored for residents of <b>Munich and Bavaria</b>.
            </p>

            <div className="test-image-container">
              <div className="mock-buttons">
                <button className="mock-test-btn" onClick={() => setMockTestModalOpen(true)}>
                  Take Mock Test 2026
                  <MdKeyboardArrowRight className="rightArrow" style={{ fontSize: '25px' }} />
                </button>

                <button className="qa-btn" id='qa-btn' onClick={fetchQuestions} disabled={loading}>
                  {loading ? (
                    <span className="loading-content"><span className="spinner" /> Loading...</span>
                  ) : (
                    `310 Questions & Answers`
                  )}
                  <MdKeyboardArrowRight className='rightArrow' style={{ fontSize: '25px' }} />
                </button>

                <button
                  className="mock-test-btn"
                  id='eligibilityAd'
                  onClick={() => window.open("https://service.muenchen.de/intelliform/forms/01/02/02/einbuergerung-quick-check/index", "_blank", "noopener,noreferrer")}
                >
                  <img src="/images/Ads/eligibility.png" alt="Eligibility Check" className="ad-image" id='eligibility-ad-image' />
                  Check Your Eligibility <MdKeyboardArrowRight className="rightArrow" style={{ fontSize: '25px' }} />
                </button>
              </div>
            </div>

            <div className="test-info">

              <h2 className="test-desc">1. Exam Overview: Quick Facts</h2>

              <table className="seo-facts-table">
                <thead>
                  <tr>
                    <th>Feature</th>
                    <th>Official Requirement (BAMF 2026)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Total Questions</td>
                    <td>33 (selected from a pool of 310)</td>
                  </tr>
                  <tr>
                    <td>Passing Score</td>
                    <td>17 correct answers</td>
                  </tr>
                  <tr>
                    <td>Time Limit</td>
                    <td>60 Minutes</td>
                  </tr>
                  <tr>
                    <td>Exam Fee</td>
                    <td>€25 (payable at Munich testing centers)</td>
                  </tr>
                  <tr>
                    <td>Bavaria Focus</td>
                    <td>30 General questions + 3 Specific to Bavaria</td>
                  </tr>
                </tbody>
              </table>

              <h2 className="test-desc">2. Take the Munich Mock Exam</h2>

              <p>
                Our simulator mimics the official testing conditions used at
                <b> Munich testing centers</b> like the <b>MVHS</b> or
                <b> BRK-Kreisverband München</b>. We randomly select questions
                from the four core subject areas:
              </p>

              <ul>
                <li><b>Life in a Democracy:</b> The German Constitution (Grundgesetz) and legal rights.</li>
                <li><b>History and Responsibility:</b> 20th-century history and Germany's social evolution.</li>
                <li><b>Humans and Society:</b> Cultural norms, religious freedom, and the education system.</li>
                <li><b>Bavaria Specifics:</b> Questions specific to the Free State of Bavaria.</li>
              </ul>

              <h2 className="test-desc">3. How to Book the Einbürgerungstest in Munich</h2>

              <ol>
                <li>
                  <b>Register:</b> Contact a local Munich testing center such as
                  the <b>Münchner Volkshochschule (MVHS)</b> or
                  <b> BRK-Kreisverband München</b>.
                </li>
                <li>
                  <b>Documents:</b> Bring a valid ID/Passport and approximately €25
                  for the registration fee.
                </li>
                <li>
                  <b>Practice:</b> Use the Munich Indians online tool to master
                  all 310 questions before your exam date.
                </li>
                <li>
                  <b>Results:</b> Certificates are typically issued by the BAMF
                  and sent to your Munich address within 2 to 4 months.
                </li>
              </ol>

              <h2 className="test-desc">Frequently Asked Questions (FAQ)</h2>

              <ol className="faq-list">
                <li className="faq-item">
                  <p><b>How many questions are in the German citizenship test?</b></p>
                  <p>
                    There are 33 questions in total. 30 are general and 3 are state-specific
                    (e.g., Bavaria).
                  </p>
                </li>

                <li className="faq-item">
                  <p><b>What is the pass mark for the Einbürgerungstest?</b></p>
                  <p>
                    You must answer at least 17 out of 33 questions correctly to pass.
                  </p>
                </li>

                <li className="faq-item">
                  <p><b>Where can I take the test in Munich?</b></p>
                  <p>
                    Popular locations include MVHS (Einsteinstr. 28) and BRK Munich (Goethestr. 53).
                  </p>
                </li>

                <li className="faq-item">
                  <p><b>Is the 3-year fast-track citizenship still available?</b></p>
                  <p>
                    As of late 2025/early 2026, the standard residency requirement is 5 years,
                    though exceptions still exist for spouses of German citizens.
                  </p>
                </li>
              </ol>
              <p className="disclaimer">
                <span className='disclaimer_span'>Disclaimer: <br /></span>
                The Federal Office (BAMF) provides the official 310 questions. This tool is for preparation purposes only.
                <br /><br />
                <span className='disclaimer_span'>Official Source: </span><br />
                <a href="https://oet.bamf.de/ords/oetut/f?p=514:1:0" className='ToolDetailpageHyperlink' target="_blank" rel="noreferrer">
                  <span className='ToolDetailpageHyperlink'>https://oet.bamf.de/ords/oetut/f?p=514:1:0</span>
                </a>
              </p>
            </div>
          </div>

          <div className="tools-advertisement">
            <SideAds />
          </div>
        </div>
      </div>

      <Footer />

      <ConfirmModal
        isOpen={isMockTestModalOpen}
        title={modalTexts.StartTest.title}
        subtitle={modalTexts.StartTest.subtitle}
        confirmText={modalTexts.StartTest.confirmText}
        cancelText={modalTexts.StartTest.cancelText}
        loading={loadingTest}
        onConfirm={startMockTest}
        onCancel={() => setMockTestModalOpen(false)}
      />

      <ModalBox
        type="newsletter"
        noOfTimesToShow={2}
        title={modalStrings.newsletter.title}
        text={modalStrings.newsletter.text}
        buttonText={modalStrings.newsletter.buttonText}
        showInput={true}
        autoShowDelay={5000}
        showOnEveryRefresh={true}
        isAnyModalOpen={openModalType !== null && openModalType !== "newsletter"}
        onModalStateChange={handleModalStateChange}
      />
    </>
  );
};

export default ToolDetailsPage;